<template lang="pug">
ul.nav.nav-pills.pull-right.fix
  li
    router-link(
        :class='$route.path == `/sistema/clientes/${$route.params.id}` || $route.path === "/sistema/clientes/novo" ? "btn-warning" : "text-warning"'
        :to='`/sistema/clientes/${$route.params.id ? $route.params.id : "novo"}`')
      i.fa.fa-address-book-o
      |  Cliente
  li(:class='getActive(`/sistema/clientes/${$route.params.id}/agenda`)', v-if='$route.params.id')
    a(:href='`/sistema/clientes/${$route.params.id}/agenda`', @click.prevent='link("agenda")')
      i.fa.fa-calendar-check-o
      |  Agenda
  li
    a(:class="$route.path === '/sistema/vendas/'+ $route.params.idVenda +'/'+$route.params.id || $route.path === '/sistema/clientes/'+ $route.params.id +'/vendas'  ? 'btn-success' : 'text-success'", v-if='$route.params.id'
      :href='`/sistema/clientes/${$route.params.id}/vendas`', @click.prevent='link("vendas")')
      i.fa.fa-cart-plus
      |  Venda
</template>

<script>
export default {
  methods: {
    getActive (url) {
      return {
        active: this.$route.path === url
      }
    },
    getUrl (type) {
      return `/sistema/clientes/${this.$route.params.id}/${type}`
    },
    link (url) {
      this.$router.push(`/sistema/clientes/${this.$route.params.id}/${url}`)
    }
  }
}
</script>

<style lang="stylus" scoped>
.fix
  z-index 2
  position relative
</style>
